import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ModalDirective} from "ngx-bootstrap/modal";

@Component({
    standalone: false,
    selector: 'cb-modal-confirm',
    templateUrl: 'confirm.component.html'
})
export class ConfirmComponent {
    @Output() onConfirm = new EventEmitter();
    @Input()  title: string = "";
    @Input()  content: string = "";
    // 未指定時はテンプレート側で common.save / common.close を訳して表示する。
    @Input()  confirmButton: string = "";
    @Input()  closeButton: string = "";
    @Input()  modalClass: string = "";
    @ViewChild('modal') public modal:ModalDirective;

    confirm(){
        this.onConfirm.emit();
        this.modal.hide();
    }

    show(){
        this.modal.show();
    }
}
